//export const BASE_URL = "https://crm.bsplinternal.com/crmUserService";
export const BASE_URL = "https://apidev.chaincrm.io";
// export const TOKEN_BASE_URL = "https://apidev.chaincrm.io/auth";
export const EXPLORER_URL = "https://testnetexplorer.diamcircle.io/";
//export const SOCKET_BASE_URL = "https://crm.bsplinternal.com/crmSocket";
export const SOCKET_BASE_URL = "https://devsocket.chaincrm.io";
